@for (thread of commentFace$ | async; track thread.id) {
  @if (!thread.resolved || showResolved) {
    @if (thread.position?.x | isArray) {
      <div
        class="comment-area"
        [class.visible]="selectedThreadId === thread.id"
        [style.left]="
          containerOffset +
          bounds().x +
          (thread.displayPosition.x - thread.displayPosition.width / 2) * bounds().width +
          'px'
        "
        [style.top]="
          bounds().y + (thread.displayPosition.y - thread.displayPosition.height / 2) * bounds().height + 'px'
        "
        [style.width]="(thread.position.x[1] - thread.position.x[0]) * bounds().width + 'px'"
        [style.height]="(thread.position.y[1] - thread.position.y[0]) * bounds().height + 'px'"
      ></div>
    }
    @if (
      thread
        | canShowFace
          : asset
          : asset.type === 'video' &&
              videoTime &&
              (thread.position.frame
                | videoTimeIsInRange: videoTime.currentSecond : videoTime.durationSeconds : videoTime.durationFrames)
          : activePage
    ) {
      <div
        class="comment-face"
        draggable="false"
        (mouseover)="threadHover.emit(thread)"
        (mouseout)="threadHover.emit(undefined)"
        [style.left]="containerOffset + bounds().x + thread.displayPosition.x * bounds().width + 'px'"
        [style.top]="bounds().y + thread.displayPosition.y * bounds().height + 'px'"
        [class.resolved]="thread.resolved"
        [class.selected]="selectedThreadId === thread.id"
        [class.other-selected]="selectedThreadId && selectedThreadId !== thread.id"
        [class.hover]="hoverThreadId === thread.id"
        [class.transition-pos]="transitionPosition && !dragging()"
        [class.dragging]="dragging()?.id === thread.id"
        [class.allow-dragging]="galleryPermissions.can_edit || (thread.user || thread.guest | isCurrentUser)"
        (mousedown)="mouseDown(thread, $event)"
        (mousemove)="mouseMove($event)"
        (mouseup)="mouseUp($event)"
        (click)="click($event, thread)"
      >
        <div class="drag-chute"></div>
        @if (thread.resolved) {
          <app-svg src="/assets/icons/check.svg"></app-svg>
        } @else {
          <app-avatar [user]="thread.user || thread.guest"></app-avatar>
        }
      </div>
    }
  }
}
